import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
} from "@angular/core";

@Component({
    selector: "loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
    standalone: false
})
export class LoaderComponent implements OnChanges {
  @Input()
  show: boolean = false;

  @Input()
  delay: number = 200;

  private showTimer: any;

  constructor(private element: ElementRef<HTMLElement>) {
    element.nativeElement.hidden = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.show) {
      if (this.show) {
        this.showSpinner();
      } else {
        this.hideSpinner();
      }
    }
  }

  private showSpinner() {
    if (this.showTimer) {
      return;
    }
    this.showTimer = setTimeout(() => {
      this.element.nativeElement.hidden = false;
    }, this.delay);
  }

  private hideSpinner() {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
    }
    this.showTimer = null;
    this.element.nativeElement.hidden = true;
  }
}
